import { path } from 'ramda';
import { IOfferState } from '../../../../shared/redux/reducers';
import { getLocationPath, isObjectSplits } from '../../../../shared/utils';
import { notEquals } from './notEquals';

const getJkId = (offer: IOfferState) => path(['geo', 'jk', 'id'], offer);
const getJkHouseId = (offer: IOfferState) => path(['geo', 'jk', 'house', 'id'], offer);
const getBusinessCenterId = (offer: IOfferState) => path(['businessShoppingCenter', 'id'], offer);
const getPhotosCount = (offer: IOfferState) => path(['photos', 'length'], offer);
const getCoordinates = (offer: IOfferState) => path(['geo', 'coordinates'], offer);
const getGeoId = (offer: IOfferState) => path(['geo', 'geoId'], offer);
const getGeoType = (offer: IOfferState) => path(['geo', 'geoType'], offer);

/**
 * Возвращает признак того, нужно ли загрузить новое ФВУ в ответ на обновление данных объявления.
 * Поскольку условий много, и отправлять для каждого изменения экшен накладно с точки зрения ререндера,
 * было принято решение отправлять всего 1 экшен.
 */
export function shouldLoadPublishTermsAfterOfferUpdate(
  offer: IOfferState = {} as IOfferState,
  prevOffer: IOfferState = {} as IOfferState,
): boolean {
  const isOfferIdChanged = offer.id !== prevOffer.id;
  const isCategoryChanged = offer.category !== prevOffer.category;
  const isHomeownerChanged = offer.isByHomeowner !== prevOffer.isByHomeowner;
  const isGeoIdChanged = getGeoId(offer) !== getGeoId(prevOffer);
  const isGeoTypeChanged = getGeoType(offer) !== getGeoType(prevOffer);
  const isPhotosCountChanged = getPhotosCount(offer) !== getPhotosCount(prevOffer);
  const isJkIdChanged = getJkId(offer) !== getJkId(prevOffer);
  const isJkHouseIdChanged = getJkHouseId(offer) !== getJkHouseId(prevOffer);
  const isBusinessCenterIdChanged = getBusinessCenterId(offer) !== getBusinessCenterId(prevOffer);
  const isObjectSplitsChanged = isObjectSplits(offer) !== isObjectSplits(prevOffer);

  const isLocationPathChanged = notEquals(getLocationPath(offer), getLocationPath(prevOffer));
  const isCoordinatesChanged = notEquals(getCoordinates(offer), getCoordinates(prevOffer));

  return (
    isOfferIdChanged ||
    isCategoryChanged ||
    isHomeownerChanged ||
    isLocationPathChanged ||
    isGeoIdChanged ||
    isGeoTypeChanged ||
    isCoordinatesChanged ||
    isPhotosCountChanged ||
    isJkIdChanged ||
    isJkHouseIdChanged ||
    isBusinessCenterIdChanged ||
    isObjectSplitsChanged
  );
}
